import React, { useCallback, useEffect, useRef, useState } from "react";
import "./ConditionSearch.less";
import IconFont, { IconSearch } from "@/components/icon";
import { AutoComplete, Checkbox, Input, message, Tooltip } from "antd";
import Api from "@/components/Joyspace/api";
import folderSharePng from "@/assets/img/folder.png";
import { SearchGlobalContext } from "./utils";
import { throttle } from "lodash";
import lodashTrim from "lodash/trim";
import { analysisLog } from "@/utils/logAnalytics";

const CheckboxGroup = Checkbox.Group;

export function ConditionSearchJoyItem({
  t,
  onClose,
  setFolderIds,
  setType,
  ConditionVisible,
  setJoyTypeList,
  setFileTypeList,
  setSearchValue
}: {
  t: any;
  ConditionVisible: boolean;
  onClose: Function;
  setFolderIds: Function;
  setType: Function;
  setJoyTypeList: Function;
  setFileTypeList: Function;
  setSearchValue: Function;
}) {
  const { types, folderIds, joyTypeList, fileTypeList, searchValue } = React.useContext(
    SearchGlobalContext
  );
  const [defVal, setDefVal] = useState<[]>([]);
  const [isChange, setIsChange] = useState<boolean>(false);
  const [autoOpen, setAutoOpen] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);
  const inputRef: any = useRef({});
  const TypeList: any = useRef(null);
  let fileTypeLists = useRef<any>([]);
  fileTypeLists.current = fileTypeList;

  const onChange = (list: any) => {
    setType(list);
  };

  const handleChange = async (e: any) => {
    if (visible) return;
    setFolderIds(e);
    analysisLog("xtbg_joyspace_search_folder_position", "72");
  };
  // 文件类型
  const secrchTypes = useCallback(async () => {
    try {
      Api.categories
        .searchTypes()
        .then((res) => {
          if (res) {
            const value = res.map((i: any) => {
              return {
                label: i.name,
                value: i.type
              };
            });
            setJoyTypeList(value);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      return;
    }
  }, [setJoyTypeList]);

  useEffect(() => {
    if (!ConditionVisible || joyTypeList?.length) return;
    secrchTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secrchTypes, ConditionVisible]);
  // 搜索文件夹
  const searchType = (val: string) => {
    try {
      Api.categories
        .searchFolder(val || "")
        .then((res) => {
          if (res) {
            const value = res.map((i: any) => {
              return {
                value: i.name,
                id: i.id
              };
            });
            setDefVal(value);
            setAutoOpen(value.length > 0 ? true : false);
            inputRef.current && inputRef.current.focus();
          } else {
            setAutoOpen(false);
            setDefVal([]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      return;
    }
  };

  const onSearchType = useRef(throttle(searchType, 300)).current;

  useEffect(() => {
    if (!lodashTrim(searchValue)) {
      setTimeout(() => {
        setDefVal([]);
        setAutoOpen(false);
      }, 400);
      return;
    }
    if (isChange) {
      return;
    }
    onSearchType(searchValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isChange, searchValue]);

  const setOnChange = useCallback(
    (val: string) => {
      setSearchValue(val);
    },
    [setSearchValue]
  );

  // 清除操作
  const handleClear = useCallback(
    (type) => {
      switch (type) {
        case "clearAll":
          setJoyTypeList(joyTypeList);
          setFileTypeList([]);
          setOnChange("");
          setFolderIds([]);
          setType([]);
          setDefVal([]);
          return;
        case "joyType":
          setJoyTypeList(joyTypeList);
          setType([]);
          return;
        case "joyFile":
          setFileTypeList([]);
          setOnChange("");
          setFolderIds([]);
          setDefVal([]);
          return;
        default:
          return null;
      }
    },
    [setJoyTypeList, joyTypeList, setFileTypeList, setOnChange, setFolderIds, setType]
  );

  const delFileItem = (i: any) => {
    if (!i) return;
    setVisible(true);
    const idx = fileTypeLists.current.findIndex((item: any) => item.id === i.id);
    const idx2 = (folderIds || [])?.findIndex((a: any) => a === i.id);
    fileTypeLists.current.splice(idx, 1);
    setFileTypeList(fileTypeLists.current);
    if (idx2 !== -1) {
      const folderIds_ = (folderIds || []).filter((item: any) => {
        return item !== i.id;
      });
      setFolderIds(folderIds_);
    }
    setTimeout(() => {
      setVisible(false);
    }, 300);
  };

  const hadleFileItem = (item: any) => {
    if (fileTypeLists.current.length >= 5) {
      return message.warning("最多添加5个文件夹");
    }
    const idx = fileTypeLists.current.findIndex((user: any) => user.id === item.id);
    if (idx === -1) {
      fileTypeLists.current.unshift({
        ...item,
        label: item.value,
        value: item.id
      });
    }
    inputRef.current && inputRef.current.blur();
    setFileTypeList(fileTypeLists.current);
    TypeList.current = fileTypeLists.current;
    setAutoOpen(false);
  };

  return (
    <div className="ConditionSearchJoyItem">
      <div className="SearchJoyItem_type">
        <header>
          <h3 className={`${types?.length || folderIds?.length ? "Highlight" : ""}`}>
            <IconFont type="iconpc_ic_tjshaixuan_search" style={{ marginRight: 3 }} />
            {types?.length || folderIds?.length
              ? "已启用筛选"
              : t("Condition.conditional filtering")}
          </h3>
          <div className="onClear">
            {!!(types?.length || folderIds?.length) && (
              <>
                <span
                  className="text"
                  onClick={() => {
                    handleClear("clearAll");
                  }}
                >
                  {t("Condition.clearAll")}
                </span>
                <div className="line" />
              </>
            )}
            <IconFont
              type="iconic_pc_im_deletee"
              onClick={() => {
                onClose();
              }}
            />
          </div>
        </header>
        <div className="SearchJoyItem_title">
          <h4>{t("Condition.File filtering")}</h4>
          {!!types?.length && (
            <span
              className="del"
              onClick={() => {
                handleClear("joyType");
              }}
            >
              {t("Condition.clear")}
            </span>
          )}
        </div>
        {/* 后端接口返回类型 */}
        <div
          className="SearchJoyItem_list_item"
          onClick={(e: any) => {
            if (e.target.value) {
              analysisLog(
                "xtbg_joyspace_search_file_type",
                "71",
                JSON.stringify({ type: e.target.value })
              );
            }
          }}
        >
          <CheckboxGroup options={joyTypeList} value={types} onChange={onChange} />
        </div>
      </div>
      <div className="SearchJoy_file">
        <div className="SearchJoyItem_title">
          <h4>{t("Condition.file location")}</h4>
          {!!folderIds?.length && (
            <span
              className="del"
              onClick={() => {
                handleClear("joyFile");
              }}
            >
              {t("Condition.clear")}
            </span>
          )}
        </div>
        <AutoComplete
          options={defVal}
          open={autoOpen}
          dropdownClassName="search_condition_Render"
          value={searchValue}
          dropdownRender={(menu) => (
            <div
              className="search_condition_box"
              onMouseDown={(e) => {
                e.preventDefault();
              }}
            >
              {(menu.props.options || []).map((i: any) => {
                return (
                  <div
                    className="search_condition_item"
                    key={i.id}
                    onClick={(e) => {
                      e.stopPropagation();
                      hadleFileItem(i);
                    }}
                  >
                    <img src={folderSharePng} alt="img" />
                    <span className="ellipsis">{i.value}</span>
                  </div>
                );
              })}
            </div>
          )}
        >
          <Input
            ref={inputRef}
            prefix={IconSearch}
            placeholder={t("Condition.input placeholder")}
            onChange={(event: any) => {
              event.persist();
              const val = event.target.value;
              setOnChange(val);
            }}
            onCompositionStart={() => {
              setIsChange(true);
            }}
            onCompositionEnd={(event: any) => {
              setOnChange(event.target.value);
              setIsChange(false);
            }}
            onFocus={() => {
              if (defVal) {
                setAutoOpen(true);
              }
            }}
            onBlur={() => {
              setAutoOpen(false);
            }}
            allowClear
          />
        </AutoComplete>
        {!!fileTypeList?.length && (
          <div className="fileTypeList">
            {/* <CheckboxGroup options={fileTypeList} onChange={handleChange} value={folderIds} /> */}
            <Checkbox.Group onChange={handleChange} value={folderIds}>
              {fileTypeList.map((item: any) => {
                return (
                  <div className="listItem" key={item.id}>
                    <Tooltip title={item.label}>
                      <Checkbox value={item.id} className="ellipsis">
                        <img src={folderSharePng} alt="img" />
                        {item.label}
                      </Checkbox>
                    </Tooltip>
                    <IconFont
                      type="iconic_pc_im_deletee"
                      onClick={() => {
                        delFileItem(item);
                      }}
                    />
                  </div>
                );
              })}
            </Checkbox.Group>
          </div>
        )}
      </div>
    </div>
  );
}
